export default "__VITE_ASSET__BWe5QbkW__"